export default __webpack_public_path__ + "static/media/intro-section.294e299b.png";